var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled/macro';
var TitleContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin-bottom: 10px;\n  position: relative;\n"], ["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  margin-bottom: 10px;\n  position: relative;\n"])), function (props) { return props.theme.layout.title.size; }, function (props) { return props.theme.layout.title.weight; }, function (props) { return props.theme.layout.title.color; });
export var Title = function (_a) {
    var children = _a.children;
    return (React.createElement(TitleContainer, null, children));
};
var templateObject_1;
//# sourceMappingURL=Title.js.map